/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S3_R9_PurposeInputs */

const tr_cerez_s3_r9_purpose = /** @type {(inputs: Cerez_S3_R9_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seçili firmanın bu tarayıcıda hatırlanması (yerel depolama)`)
};

const en_cerez_s3_r9_purpose = /** @type {(inputs: Cerez_S3_R9_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remembering the selected company in this browser (local storage)`)
};

const de_cerez_s3_r9_purpose = /** @type {(inputs: Cerez_S3_R9_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speichern der ausgewählten Firma in diesem Browser (lokaler Speicher)`)
};

const ru_cerez_s3_r9_purpose = /** @type {(inputs: Cerez_S3_R9_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранение выбранной компании в этом браузере (локальное хранилище)`)
};

/**
* | output |
* | --- |
* | "Remembering the selected company in this browser (local storage)" |
*
* @param {Cerez_S3_R9_PurposeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s3_r9_purpose = /** @type {((inputs?: Cerez_S3_R9_PurposeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S3_R9_PurposeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s3_r9_purpose(inputs)
	if (locale === "de") return de_cerez_s3_r9_purpose(inputs)
	if (locale === "ru") return ru_cerez_s3_r9_purpose(inputs)
	return tr_cerez_s3_r9_purpose(inputs)
});